import { Contact } from './contact.interface';
import { Contract } from './contract.interface';
import { Color } from '@app/shared/models/color.model';

export interface InvoicesSummary {
  validInvoices: number;
  invalidInvoices: number;
  totalInvoices: number;
  invoicesBelowThreshold: number;
}

export type Invoice = {
  prm: string;
  timestamp: string;
  contract: string[];
  documentId?: string;
  status: string;
  typeBill: string;
  finalContacts?: Contact[];
  comment?: string;
  archived: boolean;
  DateCalcul: string;
  DateDebutCalcul: string;
  DateFinCalcul: string;
  RES_CT?: Article;
  RES_PROD?: Article;
  RES_GESTION?: Article;
  RES_GESTION_VAR?: Article;
  RES_CM?: Article;
  DET_M0?: Article;
  RES_GC?: Article;
  RES_GO?: Article;
  RES_TVA?: Article;
  RES_CT_TTC?: Article;
  DET_SPOT?: Article;
  DET_FIXE?: Article;
  RES_SPOT?: Article;
  RES_BLOC?: Article;
  RES_REGUL?: Article;
  RES_HNEG?: Article;
  DET_HNEG?: Article;
  DET_TUNNEL?: Article | Article[];
  DET_REGUL?: Article | Article[];
  sentDate: string;
  dateGenerated: string;
  tracking?: string;
  montantHT: number;
  montantTTC: number;
  quantity?: string;
  failedEmails?: string[];
  deliveryStatuses?: Record<string, DeliveryStatus>;
  ArticleDetails: Article[];
  idFact?: string;
  allPrms: string[];
  multisite?: boolean;
  tunnelPercentage?: number;
} & Contract;

export enum Status {
  EDITABLE = 'EDITABLE',
  GENERATED = 'GENERATED',
  SENT = 'SENT',
  VALIDATED = 'VALIDATED',
  REFUSED = 'REFUSED',
  ERROR = 'ERROR',
  ERROR_SENDING = 'ERROR_SENDING',
  GENERATING = 'GENERATING',
  TO_GENERATE = 'TO_GENERATE',
}

export enum TypeBill {
  DRAFT = 'DRAFT',
  AUTOFACTURATION = 'AUTOFACTURATION',
  AUTOAVOIR = 'AUTOAVOIR',
}

export enum PriceType {
  REEL = 'REEL',
  ESTIME = 'ESTIME',
  DEFINITIF = 'DEFINITIF',
}

export interface Article {
  code: string;
  libelle: string;
  montant: string;
  uniteMontant: string;
  prix?: string;
  quantite?: string;
  unitePrix?: string;
  uniteQuantite?: string;
  typePrix?: string;
}

export enum StatusTracking {
  VALIDATED = 'Validée',
  REFUSED = 'Refusée',
  STUDY = 'À l’étude',
}

export const StatusTrackingOptions = Object.entries(StatusTracking).map(([value, label]) => ({
  value,
  label,
}));

/**
 * Mapping status tracking
 * @param status Le statut de suivi
 * @returns Le libellé correspondant
 */
export function mapStatusTracking(status: string): string {
  switch (status) {
    case 'VALIDATED':
      return StatusTracking.VALIDATED;
    case 'REFUSED':
      return StatusTracking.REFUSED;
    case 'STUDY':
      return StatusTracking.STUDY;
    default:
      return '-';
  }
}

export function getSelectStateClass(tracking?: string) {
  return tracking ? tracking.toLowerCase() : 'empty';
}

export enum BrevoDeliveryStatus {
  SENT = 'SENT',
  DELIVERED = 'DELIVERED',
  BLOCKED = 'BLOCKED',
  ERROR = 'ERROR',
  CLICK = 'CLICK',
  OPENED = 'OPENED',
  UNIQUE_PROXY_OPEN = 'UNIQUE_PROXY_OPEN',
}

export type DeliveryStatus = {
  email: string;
  status: BrevoDeliveryStatus;
  messageId?: string;
  eventDate: string;
  producerName?: string;
};

export function mapDeliveryStatusLabel(status: string): string {
  switch (status) {
    case BrevoDeliveryStatus.SENT:
      return 'Envoyé';
    case BrevoDeliveryStatus.DELIVERED:
      return 'Délivré';
    case BrevoDeliveryStatus.OPENED:
      return 'Ouvert';
    case BrevoDeliveryStatus.UNIQUE_PROXY_OPEN:
      return 'Ouvert';
    case BrevoDeliveryStatus.CLICK:
      return 'Cliqué';
    case BrevoDeliveryStatus.BLOCKED:
      return 'Bloqué';
    case BrevoDeliveryStatus.ERROR:
      return 'Erreur';
    default:
      return 'Inconnu';
  }
}

export function mapDeliveryStatusColor(status: string): Color {
  switch (status) {
    case BrevoDeliveryStatus.SENT:
      return Color.info500;
    case BrevoDeliveryStatus.UNIQUE_PROXY_OPEN:
      return Color.info500;
    case BrevoDeliveryStatus.DELIVERED:
      return Color.success300;
    case BrevoDeliveryStatus.OPENED:
      return Color.success300;
    case BrevoDeliveryStatus.CLICK:
      return Color.success300;
    case BrevoDeliveryStatus.BLOCKED:
      return Color.warning500;
    case BrevoDeliveryStatus.ERROR:
      return Color.danger500;
    default:
      return Color.grey500;
  }
}

export function toDeliveryStatusList(deliveryStatuses?: Record<string, DeliveryStatus>): DeliveryStatus[] {
  return deliveryStatuses ? Object.values(deliveryStatuses) : [];
}
